import { Control } from './control';
import { Request } from 'src/app/parametrage/core/model/request';

export class ControlByRequest
{
    id: number|undefined;
    avis:String;
    isDeleted:Boolean;
    createBy:String;
    createAt:String;
    updateBy:String;
    updateAt:String;
    control:Control;
    request:Request;
}